import { useContext } from 'react';
import UploadedImagesContext from '@/components/FileAttachments/UploadedImagesContext';
import FieldContext from '../../../FieldContext';
import PortfolioItemContext from '../../../../../PortfolioItemContext';
import { type UploadedImage } from '@/lib/types';
import useFieldImages from '../useFieldImages';
import type React from 'react';
import { type WritableDraft } from 'immer';

type TextFieldUploadedImagesContextProviderProps = {
  children: React.ReactNode;
};

const TextFieldUploadedImagesContextProvider = ({
  children,
}: TextFieldUploadedImagesContextProviderProps) => {
  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);
  const field = useContext(FieldContext);

  const images = useFieldImages();

  return (
    <UploadedImagesContext.Provider
      value={{
        images,
        imagesEndpoint: `${portfolioItemApiEndpoint}/${field.id}/images`,
        addImageToLocalState: (image: UploadedImage): void => {
          setPortfolioItem(portfolioItem => {
            if (typeof portfolioItem.fieldValues[field.id] === 'undefined') {
              portfolioItem.fieldValues[field.id] = {
                typeSpecificValues: {},
                images: {},
                externalFiles: {},
              };
            }

            portfolioItem.fieldValues[field.id].images[image.id] = image;
          });
        },
        updateImageInLocalState: (
          image: UploadedImage,
          stateUpdater: (image: WritableDraft<UploadedImage>) => void,
        ): void => {
          setPortfolioItem(portfolioItem => {
            stateUpdater(portfolioItem.fieldValues[field.id].images[image.id]);
          });
        },
        removeImageFromLocalState: (image: UploadedImage): void => {
          setPortfolioItem(portfolioItem => {
            delete portfolioItem.fieldValues[field.id].images[image.id];
          });
        },
      }}
    >
      {children}
    </UploadedImagesContext.Provider>
  );
};

export default TextFieldUploadedImagesContextProvider;
